import { render, staticRenderFns } from "./IconAndTitle.vue?vue&type=template&id=bfa5ba6c&"
import script from "./IconAndTitle.vue?vue&type=script&lang=js&"
export * from "./IconAndTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports